import React from 'react';

import {}  from 'react-dom'

import { Container, Row, Col , Card  } from 'react-bootstrap';

import imgCarrossel from '../../assets/img/carrosel-image-01.png';

// import GoogleShareToClassRoom from '../index';
import GoogleShareToClassRoom from '../../components/Classroom'


var sectionStyle = {
   background: `#CCC`,
}

function LessonPlan() {
  return (
    <>



    <Container fluid style={sectionStyle} className='pt-5'>

      <Row>
      <Col lg={1} />
      <Col lg={5} style={{justifyContent:'center'}}>
        <Card style={{ background:'#CCC', border: 'none', marginTop:45 }}>
        <Card.Img variant="top" src={imgCarrossel} />
          <Card.Body>
            <Card.Text>
              Cerâmicas peruanas na exposição Museu Nacional Vive - Arqueologia do Resgate, a primeira com peças retiradas do incêndio, no Centro Cultural Banco do Brasil.
            </Card.Text>

            Compartilhe este conteúdo na sua turma do Classroom! 
            <GoogleShareToClassRoom
                body="Cerâmicas peruanas na exposição Museu Nacional Vive - Arqueologia do Resgate, a primeira com peças retiradas do incêndio, no Centro Cultural Banco do Brasil."
                itemType="assignment"
                url="https://museuflix.web.app/catalog#exemplo"
                size={50}
                title="Exemplo de Compartilhamento"
                theme="green"
                onShare={(type) => console.log(`GoogleShareToClassRoom:${type}`)}
                onShareComplete={() => console.log('GoogleShareToClassRoom:onShareComplete')}
                onShareStart={() => console.log('GoogleShareToClassRoom:onShareStart')}
              />


          </Card.Body>
        </Card>
      </Col>
      
      <Col lg={1} />
      </Row>

    </Container>

    </>
  );
}

export default LessonPlan;

/*
 <GoogleShareToClassRoom
                body="Clique para compartilhar no Google Classroom"
                itemType="assignment"
                url="https://museuflix.web.app/catalog#exemplo"
                size={50}
                title="Examplo de Compartilhamento"
                theme="light"
                onShare={(type) => console.log(`GoogleShareToClassRoom:${type}`)}
                onShareComplete={() => console.log('GoogleShareToClassRoom:onShareComplete')}
                onShareStart={() => console.log('GoogleShareToClassRoom:onShareStart')}
              />
*/